import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import logo from '../asset/logo.jpg'

export default function Navbar() {
	const [open, setOpen] = useState(false)

	return (
		<header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur">
			<div className="container-gg flex h-16 items-center justify-between">
				<Link to="/" className="flex items-center gap-2">
					<img src={logo} alt="GreatGrace" className="h-8 w-8" />
					<span className="text-lg font-bold text-slate-900">Great Grace International Christian Academy</span>
				</Link>

				<nav className="hidden items-center gap-6 md:flex">
					<NavLink to="/" end className={({ isActive }) => isActive ? 'text-brand font-medium' : 'text-slate-700 hover:text-slate-900'}>Home</NavLink>
					<NavLink to="/about" className={({ isActive }) => isActive ? 'text-brand font-medium' : 'text-slate-700 hover:text-slate-900'}>About</NavLink>
					<NavLink to="/academics" className={({ isActive }) => isActive ? 'text-brand font-medium' : 'text-slate-700 hover:text-slate-900'}>Academics</NavLink>
					<NavLink to="/admissions" className={({ isActive }) => isActive ? 'text-brand font-medium' : 'text-slate-700 hover:text-slate-900'}>Admissions</NavLink>
					<NavLink to="/contact" className={({ isActive }) => isActive ? 'text-brand font-medium' : 'text-slate-700 hover:text-slate-900'}>Contact</NavLink>

					<Link to="/admissions" className="btn-primary">Enroll Now</Link>
				</nav>

				<button aria-label="Toggle menu" className="md:hidden" onClick={() => setOpen(!open)}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-7 w-7 text-slate-800">
						<path fillRule="evenodd" d="M3.75 6.75a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm0 5.25a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Zm.75 4.5a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5h-15Z" clipRule="evenodd" />
					</svg>
				</button>
			</div>

			{open && (
				<div className="md:hidden border-t border-slate-200 bg-white">
					<div className="container-gg flex flex-col gap-4 py-4">
						<NavLink onClick={() => setOpen(false)} to="/">Home</NavLink>
						<NavLink onClick={() => setOpen(false)} to="/about">About</NavLink>
						<NavLink onClick={() => setOpen(false)} to="/academics">Academics</NavLink>
						<NavLink onClick={() => setOpen(false)} to="/admissions">Admissions</NavLink>
						<NavLink onClick={() => setOpen(false)} to="/contact">Contact</NavLink>
						<Link onClick={() => setOpen(false)} to="/admissions" className="btn-primary">Enroll Now</Link>
					</div>
				</div>
			)}
		</header>
	)
}







